import {connect} from 'react-redux';
import PropertyTypesComponent from './PropertyTypes';
import {fetchImagesByTags} from './redux';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../utils/constants';
import {
    ACTION_LOCATION,
    pushHandlerClickData,
    pushHandleNextData,
    pushHandlePrevData,
} from './events';
import {moduleLoaded, moduleHidden} from '../../reducers/moduleStatus';

const mapStateToProps = (state) => {
    const {
        abacus = {},
        config: {url: {basePathPrefix} = {}} = {},
        propertyTypes = {},
    } = state;

    return {
        propertyTypes,
        basePathPrefix,
        abacus,
        ACTION_LOCATION,
        pushHandlerClickData,
        pushHandleNextData,
        pushHandlePrevData,
    };
};

export const mapDispatchToProps = {
    fetchImagesByTags,
    moduleLoaded,
    moduleHidden,
};

export const PropertyTypes = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(PropertyTypesComponent, TABLET_BREAKPOINT));

PropertyTypes.displayName = 'PropertyTypes';

export default PropertyTypes;
